'use client';

import * as React from 'react';

import { WhatsAppIcon } from '@workspace/ui/components/brand-icons';
import { Button } from '@workspace/ui/components/button';

import type { CarDto } from '~/types/dtos/car-dto';

interface CarPricingCardProps {
  car: CarDto;
}

export function CarPricingCard({
  car
}: CarPricingCardProps): React.JSX.Element {
  const handleWhatsAppReservation = (): void => {
    const phoneNumber = '+40799562479';
    const message = encodeURIComponent(
      `Bună ziua! Sunt interesat de vehiculul "${car.name}" și aș dori să fac o rezervare. Mulțumesc!`
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };
  return (
    <div className="sticky top-24 space-y-6">
      {/* Pricing Card */}
      <div className="rounded-lg border shadow-sm">
        <div className="border-b p-4">
          <h3 className="text-lg font-medium">Preț închiriere</h3>
        </div>
        <div className="p-6">
          {car.onSale && car.salePrice ? (
            <div className="mb-4 flex items-baseline gap-2">
              <span className="text-primary text-3xl font-bold">
                {car.salePrice}€
              </span>
              <span className="text-muted-foreground text-sm">/zi</span>
              <span className="text-muted-foreground text-sm line-through">
                {car.price}€
              </span>
            </div>
          ) : (
            <div className="mb-4 flex items-baseline gap-2">
              <span className="text-primary text-3xl font-bold">
                {car.price}€
              </span>
              <span className="text-muted-foreground text-sm">/zi</span>
            </div>
          )}

          <div className="space-y-4">
            {/* <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Taxe și asigurare</span>
              <span className="font-medium">Incluse</span>
            </div> */}
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Kilometri incluși</span>
              <span className="font-medium">200 km/zi</span>
            </div>
            {/* <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Depozit garanție</span>
              <span className="font-medium">500€</span>
            </div> */}

            <div className="border-t pt-4">
              <Button
                onClick={handleWhatsAppReservation}
                variant="default"
                size="default"
                className="w-full"
              >
                <WhatsAppIcon className="size-5" /> Rezervă acum
              </Button>
            </div>

            {/* <div className="pt-1">
              <Link
                href="/contact"
                className={cn(
                  buttonVariants({
                    variant: 'outline',
                    size: 'default'
                  }),
                  'w-full'
                )}
              >
                Contactați-ne
              </Link>
            </div> */}
          </div>
        </div>
      </div>

      {/* Need help card */}
      {/* <div className="rounded-lg border bg-muted/30 p-6">
        <h3 className="text-lg font-medium mb-2">Aveți nevoie de ajutor?</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Echipa noastră de specialiști vă stă la dispoziție pentru orice
          întrebare.
        </p>
        <div className="flex items-center gap-3 pt-2">
          <div className="rounded-full bg-primary/10 p-2">
            <Users className="h-4 w-4 text-primary" />
          </div>
          <div>
            <p className="text-sm font-medium">Suport clienți</p>
            <p className="text-sm text-primary">+40 721 234 567</p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
